import { productSchema } from "@/utils/schema";
import { useMemo } from "react";
import Seo from "../seo";
import ProductBreadCrumb from "./ProductBreadCrumb";

const ProductSeo = ({ product, locale }) => {
  const bc_categories = useMemo(() => {
    // Check if product data is available before proceeding
    if (!product || !product.category) {
      return [];
    }
    const getCategory = (level) =>
      product?._category_?.sub_categories.find((c) => c.level === level);
    const cats = [getCategory(2), getCategory(3)].filter(Boolean);

    return cats
      .map((cat) => ({
        name: cat?.name,
        url: cat?.url_key
          ? `${cat?.url_key}-c-${cat?.category_id}`
          : `${cat?.name?.replaceAll(" ", "-")?.toLowerCase()}-c-${
              cat?.category_id
            }`,
      }))
      .filter(({ name }) => name);
  }, [product]);
  return (
    <>
      <Seo
        title={product?.name || ""}
        description={product?.meta_description}
        image={product?._media_?.image?.at(0)?.image}
      >
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(
              productSchema(product, bc_categories, locale),
              null,
              2
            ),
          }}
        />
      </Seo>
      <ProductBreadCrumb
        Current={product?.name}
        parentCategory={bc_categories}
      />
    </>
  );
};

export default ProductSeo;
